import type { SentryClient } from './type.d';

import type { EventHint, Scope } from '@sentry/core';

declare const Sentry: SentryClient | undefined;

export const captureException = (exception: unknown, hint?: EventHint, currentScope?: Scope) => {
  if (typeof Sentry !== 'undefined') {
    Sentry?.captureException(exception, hint, currentScope);
  }
};
